import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';
import icon from 'flarum/common/helpers/icon';

import UserManageSidebarUserComponent from "./UserManageSidebarUserComponent";
import UserManageSidebarInviteCodeComponent from "./UserManageSidebarInviteCodeComponent";

export default class UserManageSidebarComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.viewType = this.attrs.viewType;

    this.loading = true;
    this.listFilters = Stream("0");
    this.searchKeyword = "";
    this.searchKeywordTemp = Stream("");
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  view() {
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const viewType = this.viewType;
    let searchPlaceholder = "";

    if(this.listFilters()==0){
      searchPlaceholder = app.translator.trans('ziven-u2di.forum.map-sidebar-user-manage-search-user');
    }else if(this.listFilters()==2){
      searchPlaceholder = app.translator.trans('ziven-u2di.forum.map-sidebar-user-manage-search-invite-code')
    }

    return (
      <div>
        {this.viewType==="normal" && (
          <div className="u2diMapSideBarTitleContainier">
            <div className="u2diMapSideBarTitle">{app.translator.trans("ziven-u2di.forum.map-sidebar-user-manage-title")}</div>

            {u2diUserType9===true && (
              <div style="justify-content: normal !important;" className="u2diMapSideBarMagageArea u2diInfoItemContainer">
                <div role="search" aria-label="Search Forum" class="Search">
                  <div className="Search-input">
                    <input style="width: 170px !important;" oninput={(e) => { this.searchKeywordTemp(e.target.value) }} onsearch={(e) => {this.searchInput(e)}} className="FormControl u2diUserSearchInput" type="search" placeholder={searchPlaceholder} />
                    {this.searchKeywordTemp()!=="" && (
                      <button className="Search-clear Button Button--icon Button--link" type="button" onclick={this.clearSearch.bind(this)}>
                        {icon('fas fa-times-circle')}
                      </button>
                    )}
                  </div>
                </div>

                <div style="padding-left:9px">
                  <Select className="u2diDataSelectList" value={this.listFilters()}
                    style = "width:120px"
                    options={{
                      "0":app.translator.trans("ziven-u2di.forum.user-manage-filter-user"),
                      "2":app.translator.trans("ziven-u2di.forum.user-manage-filter-invite-code"),
                    }}
                    onchange={(e) => { 
                      this.listFilters(e);
                      this.searchKeywordTemp("");
                      this.searchKeyword = "";
                      $(".u2diUserSearchInput").val("");
                    }}
                  />
                </div>
              </div>
            )}

            <div style="height: calc(100vh - 340px)" className="u2diMapSideBarContentContainier">
              {this.listFilters()==0 && (
                <UserManageSidebarUserComponent viewType={viewType} searchKeyword={this.searchKeyword}/>
              )}

              {this.listFilters()==2 && (
                <UserManageSidebarInviteCodeComponent viewType={viewType} searchKeyword={this.searchKeyword} />
              )}
            </div>
          </div>
        )}

        {this.viewType==="mobile" && (
          <div className="u2diMapSideBarMobileContentArea">
            <div className="u2diMapSideBarMobileContentContainer">
              
            </div>
          </div>
        )}
      </div>
    );
  }

  clearSearch(e){
    $(e.target).parent().parent().find('input').val("");
    this.searchKeywordTemp("");
    this.searchInput();
  }

  searchInput(e){
    this.searchKeyword = this.searchKeywordTemp();
    m.redraw();
  }
}